import classnames from "classnames/bind";
import { useGetCurrentPx } from "libs/tailwind-css";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import styles from "./NavBar.module.scss";

import {
  SvgActiveAnalysis,
  SvgActiveCommunity,
  SvgActiveHome,
  SvgActiveMypage,
  SvgAnalysis,
  SvgCommunity,
  SvgHome,
  SvgMypage,
} from "assets/svg/Icon";
import { useAppSelector } from "store/redux/modules";
import { path } from "utils/(path)";
import { getCheckAccountRegionKorea } from "utils/getCheckKorea";
import FixedContainer from "../FixedContainer/FixedContainer";

const cn = classnames.bind(styles);

interface INavBarProps {
  navTab: number;
  setNavTab: any;
  checkFirstOpen: any;
}
const NavBar = ({ navTab, setNavTab }: INavBarProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const account = useAppSelector((state) => state.account.account);
  const accountRegion = account?.region;
  const { t } = useTranslation();
  const { getCurrentPx } = useGetCurrentPx();
  // 추가된 상태
  const [isDropdownOpen, setIsDropdownOpen] = useState(false); // 드롭다운 상태 관리
  const [isDimmed, setIsDimmed] = useState(false); // dim 상태 관리

  useEffect(() => {
    if (location.pathname === "/") {
      setNavTab(0);
    }
    if (location.pathname === path.scalp() || location.pathname === path.skin()) {
      setNavTab(1);
    }
    if (location.pathname === "/community") {
      setNavTab(2);
    }
    if (location.pathname === "/drawer") {
      setNavTab(3);
    }
    setIsDropdownOpen(false);
    setIsDimmed(false);
  }, [location.pathname]);

  const navList = [
    {
      title: t("홈"),
      icon: <SvgHome />,
      focusedIcon: <SvgActiveHome />,
    },
    {
      title: t("분석"),
      icon: <SvgAnalysis />,
      focusedIcon: <SvgActiveAnalysis />,
    },
    getCheckAccountRegionKorea(accountRegion)
      ? {
          title: t("커뮤니티"),
          icon: <SvgCommunity />,
          focusedIcon: <SvgActiveCommunity />,
        }
      : undefined,
    {
      title: t("마이페이지"),
      icon: <SvgMypage />,
      focusedIcon: <SvgActiveMypage />,
    },
  ];

  useEffect(() => {
    if (isDimmed) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isDimmed]);

  const onNavClick = (newNavTab: number) => {
    if (newNavTab === 1) {
      // 분석 클릭 시
      setIsDropdownOpen(!isDropdownOpen);
      setIsDimmed(!isDimmed);
      setNavTab(newNavTab);
    } else {
      setNavTab(newNavTab);
      setIsDimmed(false);
      setIsDropdownOpen(false);
      switch (newNavTab) {
        case 0:
          return navigate("/", { replace: true });
        case 2:
          return navigate("/community", { replace: true });
        case 3:
          return navigate("/drawer", { replace: true });
      }
    }
  };

  return (
    <>
      {isDimmed && (
        <div
          className="fixed top-0 left-0 w-full h-[calc(100%-66px)] bg-base bg-opacity-50"
          onClick={() => {
            setIsDropdownOpen(false);
            setIsDimmed(false);
          }}
        ></div>
      )}

      <div className={styles.navBarWrapper}>
        <div className={styles.navBarContainer} style={{ height: getCurrentPx(66) + "px" }}>
          {navList.map((nav, index) => {
            return (
              nav && (
                <div key={`key_${nav.title}`} onClick={() => onNavClick(index)} className={styles.navItem}>
                  {navTab === index ? nav.focusedIcon : nav.icon}
                  <div
                    className={cn("iconAltText", {
                      active: navTab === index,
                    })}
                  >
                    {nav.title}
                  </div>
                </div>
              )
            );
          })}
        </div>
      </div>

      <FixedContainer position="bottom" isHeaderOrNavExist={true}>
        <ul
          className={`flex flex-col gap-sp-12 w-[50%] translate-x-[25%] transition-all duration-500 ease-in-out overflow-hidden  ${
            isDropdownOpen ? "opacity-100" : "h-0 opacity-0"
          }`}
        >
          <li
            className="bg-primary w-full text-base-0 rounded-md border border-base-0 p-sp-8"
            onClick={() => {
              navigate(path.scalp());
            }}
          >
            <button className="text-sm w-full">{t("두피 분석")}</button>
          </li>
          <li
            className="bg-primary w-full text-base-0 rounded-md border border-base-0 p-sp-8"
            onClick={() => {
              navigate(path.skin());
            }}
          >
            <button className="text-sm w-full">{t("피부 분석")}</button>
          </li>
          <li
            className="bg-primary w-full text-base-0 rounded-md border border-base-0 p-sp-8"
            onClick={() => {
              navigate(path.historyB2B());
            }}
          >
            <button className="text-sm w-full">{t("히스토리")}</button>
          </li>
        </ul>
      </FixedContainer>
    </>
  );
};

export default NavBar;
